module.exports = __webpack_public_path__ + "teqbahn-assets/media/10.9721f09f.png";